import React from 'react';
import { IconProps } from './typing';

export const Check = ({ iconSize, color }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={iconSize}
      height={iconSize}
      viewBox="0,0,256,256"
    >
      <g
        fill={color}
        fillRule="nonzero"
        stroke="none"
        strokeWidth="1"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit="10"
        strokeDasharray=""
        strokeDashoffset="0"
        fontFamily="none"
        fontWeight="none"
        fontSize="none"
        textAnchor="none"
      >
        <g transform="scale(10.66667,10.66667)">
          <path d="M12,2c-5.53333,0 -10,4.46667 -10,10c0,5.53333 4.46667,10 10,10c5.53333,0 10,-4.46667 10,-10c0,-5.53333 -4.46667,-10 -10,-10zM16.30078,8.30078l1.39844,1.39844l-7.69922,7.70117l-3.69922,-3.70117l1.39844,-1.39844l2.30078,2.29883z"></path>
        </g>
      </g>
    </svg>
  );
};
